<form>
    <input type="text" name="name" class="col-11" [(ngModel)]='produtos.buscarProduto' placeholder="Busque código, descrição ou fornecedor">
    <a [routerLink]="['/buscar']">
      <button class="col-1" (click)="produtos.buscarProdutos()" type="buttom">
        <img src="assets/imagens/icone_buscar.svg">
    </button>
    </a>
</form>
